import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { AchDebitStatusEnum } from '../../../payments-data/payments-data.data';

export const ACH_DEBIT_SCHEMA = Object.freeze({
  STATUS: AchDebitStatusEnum.disabled,
  FEES_PERCENTAGE: 0, // floating point number
  FEES_MINIMUM: 100, // integer/subunit
  FEES_MAXIMUM: 100, // integer/subunit
  CURRENCY_CODE: '',
  MAX_PAYABLE_LIMIT: 200000, // default to $2000.00
});
const RECORD = generateSchema(ACH_DEBIT_SCHEMA);
const KEYS: any = generateKeys(ACH_DEBIT_SCHEMA);

export class AchDebit extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get status(): AchDebitStatusEnum {
    return this.get(KEYS.STATUS);
  }

  get feesPercentage(): number {
    return this.get(KEYS.FEES_PERCENTAGE);
  }

  get feesMinimum(): number {
    return this.get(KEYS.FEES_MINIMUM);
  }

  get feesMaximum(): number {
    return this.get(KEYS.FEES_MAXIMUM);
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get maxPayableLimit(): number {
    return this.get(KEYS.MAX_PAYABLE_LIMIT);
  }

  isEnabled(): boolean {
    return this.status === AchDebitStatusEnum.enabled;
  }

  isDisabled(): boolean {
    return this.status === AchDebitStatusEnum.disabled;
  }

  isIneligible(): boolean {
    return this.status === AchDebitStatusEnum.ineligible;
  }

  isUnderwritingRequired(): boolean {
    return this.status === AchDebitStatusEnum.underwriting_required;
  }
}
